import React, { useEffect, useState } from 'react';
import { heroSlides, company } from '../../mock';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronLeft, ChevronRight, Phone, MessageCircle } from 'lucide-react';

export default function Hero() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % heroSlides.length), 6000);
    return () => clearInterval(t);
  }, []);

  const s = heroSlides[i];

  const waLink = `https://wa.me/${company.whatsapp}?text=${encodeURIComponent('Hi Ewen Realtors, I want to know more about The Ewen Park.')}`;


  return (
    <section className="relative h-[100svh] w-full overflow-hidden bg-[#0f1a14]">
      {heroSlides.map((slide, idx) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-[1500ms] ${idx === i ? 'opacity-100' : 'opacity-0'}`}
        >
          <img src={slide.image} alt="" className="h-full w-full object-cover scale-105" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-[#0f1a14]/95" />
        </div>
      ))}

      <div className="relative z-10 h-full flex flex-col justify-center px-6 lg:px-24 max-w-7xl mx-auto">
        <div key={s.id} className="animate-[fadeUp_1s_ease-out]">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#c9a56a]" />
            <span className="text-[#c9a56a] text-xs uppercase tracking-[0.3em]">{s.eyebrow}</span>
          </div>
          <h1 className="font-serif text-white text-5xl md:text-7xl lg:text-8xl leading-[1.02] max-w-4xl">
            {s.title}
          </h1>
          <p className="text-white/75 mt-6 text-lg max-w-xl leading-relaxed">{s.subtitle}</p>
          <div className="flex flex-wrap gap-3 mt-10">
            <Link to="/contact">
              <Button className="bg-[#c9a56a] text-[#0f1a14] hover:bg-[#b8945a] rounded-none px-8 py-6 text-sm tracking-wider">
                Book a Site Visit <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <a href={`tel:${company.phoneRaw}`}>
              <Button variant="outline" className="bg-black/25 backdrop-blur-sm border-white/40 text-white hover:bg-white hover:text-[#0f1a14] rounded-none px-6 py-6 text-sm tracking-wider">
                <Phone className="h-4 w-4 mr-2" /> Call Now
              </Button>
            </a>
            <a href={waLink} target="_blank" rel="noreferrer">
              <Button variant="outline" className="bg-black/25 backdrop-blur-sm border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-[#0f1a14] rounded-none px-6 py-6 text-sm tracking-wider">
                <MessageCircle className="h-4 w-4 mr-2" /> WhatsApp
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="absolute bottom-10 right-6 lg:right-24 z-10 flex items-center gap-6">
        <button onClick={() => setI((i - 1 + heroSlides.length) % heroSlides.length)} className="text-white/70 hover:text-[#c9a56a] transition-colors">
          <ChevronLeft />
        </button>
        <div className="font-serif text-white text-sm">
          <span className="text-[#c9a56a]">{String(i + 1).padStart(2, '0')}</span>
          <span className="text-white/40"> / {String(heroSlides.length).padStart(2, '0')}</span>
        </div>
        <button onClick={() => setI((i + 1) % heroSlides.length)} className="text-white/70 hover:text-[#c9a56a] transition-colors">
          <ChevronRight />
        </button>
      </div>

      {/* Marquee-esque bottom band */}
      <div className="absolute bottom-0 inset-x-0 border-t border-white/10 bg-[#0f1a14]/70 backdrop-blur">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
          {[['Freehold Land', 'Registered on your name'], ['RERA Approved', 'UKREA05230000398'], ['11+ Years', 'Trusted developer'], ['500+ Families', 'Living the dream']].map(([t, s2], k) => (
            <div key={k} className="px-6 py-5">
              <div className="text-white text-sm font-medium">{t}</div>
              <div className="text-white/50 text-xs mt-1">{s2}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
